/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/sha256.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Computes the SHA256 hash of the input.
 *
 * @example
 * FROM sample_data
 * | WHERE message != "Connection error"
 * | EVAL sha256 = sha256(message)
 * | KEEP message, sha256
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'sha256',
  signatures: [
    {
      params: [
        {
          name: 'input',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'input',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
